module.exports = [{"type":"title","text":"2025-03-13"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：新增‘逐倉分倉’持倉模式"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-03-13.json
// module id = j73g
// module chunks = 3